import { render } from "./CenterModal.vue?vue&type=template&id=d8c2b76a"
import script from "./CenterModal.vue?vue&type=script&lang=js"
export * from "./CenterModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__